import { useTranslation } from "react-i18next";
import { Box, Button, Divider, IconButton, LinearProgress, Typography } from "@mui/material";

import { CloseButtonIcon } from "../../../assets/icons/gino-icons";
import SuccessfullyPurchasedFigure from "../../../assets/images/successfull-purchased-figure.png";
import { GinoAddOns } from "../../../api/services/ginoAddOns";

export const PurchasedSuccessfullyStep = ({
  onClose,
  selectedPack,
}: {
  onClose: () => void;
  selectedPack: GinoAddOns | null;
}) => {
  const { t } = useTranslation("gino", { keyPrefix: "component.ginoCreditModal" });

  return (
    <Box sx={styles.modalContent}>
      <Box sx={styles.header}>
        <IconButton onClick={onClose} size="small">
          <CloseButtonIcon />
        </IconButton>
      </Box>
      <Divider flexItem orientation="horizontal" />
      <Box sx={styles.contentContainer}>
        <Box component="img" src={SuccessfullyPurchasedFigure} alt="Successfully Purchased" sx={styles.figure} />
        <Box sx={styles.content}>
          <Typography sx={styles.title}>{t("addOnPurchasedSuccessfully")}</Typography>
          <Box sx={styles.descriptionContainer}>
            <Typography sx={styles.description}>
              {t("addOnPurchasedSuccessfullyDescription", {
                added: selectedPack?.credits,
              })}
            </Typography>
            <Typography sx={styles.description}>{t("addOnPurchasedSuccessfullyDescription2")}</Typography>
          </Box>
        </Box>
      </Box>
      <Divider flexItem orientation="horizontal" />
      <Box sx={styles.buttonContainer}>
        <Button variant="primary-md" onClick={onClose}>
          {t("okay")}
        </Button>
      </Box>
    </Box>
  );
};

const styles = {
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "640px",
    borderRadius: "var(--radius-xl, 12px)",
    background: "var(--Colors-Background-bg-primary, #FFF)",
    boxShadow:
      "0 20px 24px -4px var(--Colors-Effects-Shadows-shadow-xl_01, rgba(16, 24, 40, 0.08)), 0 8px 8px -4px var(--Colors-Effects-Shadows-shadow-xl_02, rgba(16, 24, 40, 0.03))",
  },
  header: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "12px 24px",
  },

  contentContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "32px",
    padding: "12px 0",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  figure: {
    width: "157px",
    height: "120px",
  },
  title: {
    color: "var(--Dark---1000, #111)",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 750,
    lineHeight: "normal",
  },
  descriptionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  description: {
    fontFamily: "Montserrat",
    color: "var(--Dark---800, #414141)",
    textAlign: "center",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "12px 24px",
  },
};
